import React from 'react'
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api'
import mapMarker from '../../assets/mapMarker.svg'
import config from '../../config'
import PropTypes from 'prop-types'

const Map = ({
  center,
  containerStyle,
  zoom = 10,
  apiAlreadyLoaded = false,
}) => {
  return (
    <>
      {!apiAlreadyLoaded ? (
        <LoadScript googleMapsApiKey={config.GOOGLE_APP_KEY}>
          <GoogleMap
            // onClick={onClikMap}
            mapContainerStyle={containerStyle}
            center={center}
            zoom={zoom}
          >
            <Marker position={center} icon={mapMarker} />
          </GoogleMap>
        </LoadScript>
      ) : (
        <GoogleMap
          // onClick={onClikMap}
          mapContainerStyle={containerStyle}
          center={center}
          zoom={zoom}
        >
          <Marker position={center} icon={mapMarker} />
        </GoogleMap>
      )}
    </>
  )
}

Map.propTypes = {
  center: PropTypes.object.isRequired,
  containerStyle: PropTypes.object,
  zoom: PropTypes.number,
  apiAlreadyLoaded: PropTypes.bool,
}

export default Map
